<template>
  <div class="col-sm-3">
    <img class="manual-img" src="~assets/gal_tukaikata.png" >
  </div>
</template>

<script>
export default {
  name: 'manual'
}
</script>

<style scoped>
.manual-img {
  width: 280px;
  height: 320px;
}
</style>



// WEBPACK FOOTER //
// Manual.vue?6ff90eec